import * as angular from 'angular';
import { Transition } from '@uirouter/angularjs';
import type { ThemeService } from '../Theme/mx-theme.service';
import { EventCodes } from './model/event-codes';
import type { EventService } from './services/event-service';

export const appState = {
	name: 'app',
	component: 'mxApp',
	abstract: true,
	resolve: {
		showLayout: [
			'$rootScope',
			'mx.app.ThemeService',
			'mx.shell.EventService',
			async function ($rootScope: angular.IRootScopeService, themeService: ThemeService, eventService: EventService) {
				const currentTheme = await themeService.getCurrentTheme();
				$rootScope.themeConfig = {
					themeId: currentTheme.id,
					isContrastTheme: currentTheme.isContrastTheme,
				};

				eventService.subscribeTo(
					EventCodes.ThemeChanged,
					(e, { themeId, contrastMode }) => {
						$rootScope.themeConfig = { themeId, isContrastTheme: contrastMode };
					},
					$rootScope
				);

				angular.element('body').removeClass('hideBody');
				angular.element('.mx-index-loading').removeClass('mx-index-loading');
				$('#mx-aria-initial-loading-msg').remove();
			},
		],
	},
};

export const authAppState = {
	parent: appState.name,
	name: 'authApp',
	abstract: true,
};

export const defaultAppState = {
	name: 'defaultAppState',
	parent: appState.name,
	redirectTo: function (transition: Transition) {
		return transition.router.stateService.target('shell');
	},
};
